module.exports = __webpack_public_path__ + "img/17_13.0e41f774.png";